import Layout from '../../Components/Templates/Layout';
import SpaceImage from '../../Assets/Images/nasa-space.jpg';
import { Center, Flex, Heading, Text } from '@chakra-ui/react';
import PlantListElement from '../../Components/PlantListElement';

/* Import Items */
import fiveAxisMachines, {
    WireCutMachines, 
    TurningMachines, 
    QualityMachines 
} from '../../Components/PlantListElement/plantListData';

const PlantList = () => {
    return (
        <Layout topBarMaxWidth={ 1400 }>
            <Flex flexDirection='column' flex='1'>
                <Flex flexDirection='row'>
                    <Flex 
                        flex='1' 
                        backgroundImage={ SpaceImage }
                        height='300px'
                        backgroundPosition='center'
                        backgroundSize='cover'
                    />
                </Flex>
                <Flex>
                    <Center display='flex' flex='1'>
                        <Flex 
                            flex='1' 
                            maxWidth='1400px' 
                            flexDirection='column'
                            padding='10px'
                        >
                            <Heading 
                                color='brand.orange'
                                marginTop='20px'
                                marginBottom='20px'
                            >
                                PLANT LIST
                            </Heading>
                            <Flex 
                                flexDirection='column' 
                                marginBottom='40px'
                            >
                                <Flex 
                                    p='5px'
                                    marginBottom='20px'>
                                    <Text>
                                        Here at Virtue Aerospace we host a 
                                        large amount of machinery... 
                                        Get to know our machines better by reading about
                                        them below.
                                    </Text>
                                </Flex>
                                <Flex marginBottom='40px' flexDirection='column'>
                                    <Heading as='h4' size='md' paddingBottom='10px'>5-Axis Machines</Heading>
                                    <PlantListElement items={ fiveAxisMachines }/>
                                </Flex>
                                
                                <Flex marginBottom='40px' flexDirection='column'>
                                    <Heading as='h4' size='md' paddingBottom='10px'>Wire-Cut Machines</Heading>
                                    <PlantListElement items={ WireCutMachines }/>
                                </Flex>

                                <Flex marginBottom='40px' flexDirection='column'>
                                    <Heading as='h4' size='md' paddingBottom='10px'>Turning Machines</Heading>
                                    <PlantListElement items={ TurningMachines }/>
                                </Flex>

                                <Flex marginBottom='40px' flexDirection='column'>
                                    <Heading as='h4' size='md' paddingBottom='10px'>Quality Machines</Heading>
                                    <PlantListElement items={ QualityMachines }/>
                                </Flex>
                            </Flex>
                        </Flex>
                    </Center>
                </Flex>
            </Flex>
        </Layout>
    );
};

export default PlantList;